import React from 'react';


import component, {classnames} from './component';
import ContentEditable from './ContentEditable';
import DataEditButton from './DataEditButton';

export default component('EditField', function({data, icon, valueKey, width, defaultValue, updateMethod}) {
  const editStart = () => {
    data.setIn(valueKey + 'ValueOriginal', data.get(valueKey));
    data.setIn(valueKey + 'ValueEdit', true);
  };

  const editCancel = () => {
    data.setIn(valueKey + 'ValueEdit', false);
    data.setIn(valueKey, data.get(valueKey + 'ValueOriginal'));
  };

  const persistValue = (e) => {
    if (updateMethod) {
      updateMethod().then(function(result) {
        data.setIn(valueKey + 'ValueEdit', !!result);
      });
    } else {
        data.setIn(valueKey + 'ValueEdit', false);
    }
  };

  const valueChanged = (e) => {
    data.setIn(valueKey, e.target.value);
  };

  const editCancelButton = data.get(valueKey + 'ValueEdit')
    ?
    <div className='EditField-NameButtonCancel'>
      <DataEditButton text='Сохранить' onClick={persistValue} />
      <DataEditButton text='Отмена' onClick={editCancel} />
    </div>
    :
    <DataEditButton text='Редактировать' onClick={editStart} />;

  return (
    <div className="EditField">
      {
        data.get(valueKey + 'ValueEdit')
          ?
          <ContentEditable
            html={data.get(valueKey) || ''}
            focus
            selectAllOnFocus
            onChange={valueChanged}
          />
          :
          <div className="EditField--Wrap">
            <span className="EditField-Icon">
              {icon}
            </span>
            <span className="EditField--Text">
              {data.get(valueKey) || defaultValue}
            </span>
              <span className='EditField-NameButtonEdit'>{editCancelButton}</span>
          </div>
        }
        {
          data.get(valueKey + 'ValueEdit')
            ? editCancelButton
            : null
        }
    </div>
  )
})



// WEBPACK FOOTER //
// ./src/components/EditField.js